export enum PermissionType {
  Base = 'CPM',
  Video = 'VID',
  Tutorial = 'TUT',
  Note = 'NTE',
  LegacyExam = 'EXM',
}

export enum PermissionSource {
  Direct = 'DIRECT',
}
